import React from 'react'
import { Loading } from '@shopify/polaris';
import { Prompt, PromptProps } from 'react-router';

export const PromptLoading = React.memo<PromptProps>((props) => (
    <>
        {props.when && <Loading/>}
        <Prompt {...props}/>
    </>
))